import { createAsyncThunk } from '@reduxjs/toolkit';
import { IGetBaseLLMTemplatesResponse } from '@/models/llmTemplate.model';
import { IApiError } from '@/models/apiError.model';
import { formatApiError } from '@/utils';
import { LLMTemplateAPI } from '@/api';
import { SLICE_NAME } from './models';

export const getBaseTemplates = createAsyncThunk<
  IGetBaseLLMTemplatesResponse,
  void,
  { serializedErrorType: IApiError }
>(
  `${SLICE_NAME}/getBaseTemplates`,
  async () => {
    const response = await LLMTemplateAPI.getBaseTemplates();
    return response.data;
  },
  { serializeError: formatApiError },
);
